const authActionTypes = {
  // login
  LOGIN: "LOGIN",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  // logout
  LOGOUT: "LOGOUT",
  SET_USER_TO_STORE: "SET_USER_TO_STORE",
  SET_SHOPIFY_ID_TOKEN: "SET_SHOPIFY_ID_TOKEN",
  SET_FIREBASE_AUTH_ID_TOKEN: "SET_FIREBASE_AUTH_ID_TOKEN",
};

export default authActionTypes;
